import { render, staticRenderFns } from "./sdproduct14.vue?vue&type=template&id=0c967ba4&scoped=true"
import script from "./sdproduct14.vue?vue&type=script&lang=js"
export * from "./sdproduct14.vue?vue&type=script&lang=js"
import style0 from "./sdproduct14.vue?vue&type=style&index=0&id=0c967ba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c967ba4",
  null
  
)

export default component.exports